import React, { Component } from "react";
import WorkspacePageContext from "./WorkspacePageContext";

export class Navbar extends Component {
  static contextType = WorkspacePageContext;

  toggleSidebar = () => {
    document.body.classList.toggle("fixed-left-void");
    document.querySelector(".page-wrapper").classList.toggle("enlarged");
  };
  render() {
    if (this.context) return null;
    return (
      <div>
        <div className="toggle" onClick={this.toggleSidebar}>
          <button type="button" className="tooglebutton " title="Toggle navigation" aria-label="Toggle navigation">
            <i className="fas fa-bars" aria-hidden="true"></i>
          </button>
        </div>
      </div>
    );
  }
}

export default Navbar;
